export default __webpack_public_path__ + "static/animation-b73d175eafd57a25ccae887b59068409.gif";